module.exports = __webpack_public_path__ + "media/images/ecalls/01_header_banner_bottom-6e76ca1ab64891ca921b5ccac69a3866.png";